import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

// Constants for styles
const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
const DASHBOARD_ROW_STYLE = {
	paddingTop: "20px",
	paddingBottom: "20px",
	backgroundColor: "#A7D588",
};
const TABLE_CONTAINER_STYLE = { padding: "10px" };
const DASHBOARD_CARDS = [
	{ key: "totalcourses", label: "Total Courses", bgColor: "#24A2B3" },
	{ key: "categories", label: "Total Categories", bgColor: "#E96CB4" },
];

const ACTION_CELL_STYLE = {
	fontSize: "20px",
	textAlign: "center",
	fontFamily: "Roboto, sans-serif",
};

const Coursemanagement = () => {
	const { auth } = useSelector((state) => state);
	const [courseDetails, setCourseDetails] = useState({});
	const [feedbacks, setFeedbacks] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		const fetchCourseDetails = async () => {
			if (!auth.token) return;

			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				setLoading(true);
				setError(null);

				const res = await getDataAPI(`getcoursescount`, auth.token);
				setCourseDetails(res.data.coursedetails || {});
			} catch (err) {
				console.error("Error fetching course details:", err);
				setError("Failed to load course statistics");
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch course details" },
				});
			} finally {
				setLoading(false);
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};

		fetchCourseDetails();
	}, [auth.token, dispatch]);

	// Fetch feedbacks
	useEffect(() => {
		const fetchFeedbacks = async () => {
			if (!auth.token) return;

			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				const res = await getDataAPI("getcoursefeedback", auth.token);
				console.log("res", res.data.feedbacks);
				setFeedbacks(res.data.feedbacks || []);
			} catch (err) {
				console.error("Error fetching feedbacks:", err);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch feedbacks" },
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};

		fetchFeedbacks();
	}, [auth.token, dispatch]);

	// Memoize dashboard cards to prevent unnecessary re-renders
	const dashboardCards = useMemo(() => {
		return DASHBOARD_CARDS.map((card) => (
			<div
				key={card.key}
				className="col text-format"
				style={{ backgroundColor: card.bgColor }}>
				<div className="text1">{courseDetails[card.key] || 0}</div>
				<div className="text1">{card.label}</div>
			</div>
		));
	}, [courseDetails]);

	const handleDeleteClick = useCallback(
		async (id) => {
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			try {
				const res = await postDataAPI(
					"deletecoursefeedback",
					{
						id: id,
					},
					auth.token
				);

				if (res.status === 200) {
					window.location.reload();
				}
			} catch (err) {
				console.error("Error deleting feedback:", err);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: {
						error: err.response?.data?.msg || "Error deleting feedback",
					},
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		},
		[auth.token, dispatch]
	);
	// Memoized components
	const feedbackRows = useMemo(() => {
		if (!feedbacks.length) {
			return (
				<tr>
					<td colSpan={6} className="text-center">
						No Feedbacks
					</td>
				</tr>
			);
		}
		return feedbacks.map((feedback, index) => {
			return (
				<tr key={feedback.id}>
					<td>{index + 1}</td>
					<td>{feedback.courseName}</td>
					{/* <td>{feedback.categoryName}</td>
					<td>{feedback.subcategoryName}</td> */}
					<td>{feedback.name}</td>
					<td>{feedback.email}</td>
					<td>{feedback.phone}</td>
					<td>{feedback.feedback}</td>
					<td style={ACTION_CELL_STYLE}>
						<button
							onClick={() => handleDeleteClick(feedback.id)}
							className="btn btn-danger bg-danger">
							Delete
						</button>
					</td>
				</tr>
			);
		});
	}, [feedbacks]);

	if (!auth.user) {
		return <LoginRequest />;
	}

	return (
		<>
			<Adminnavbar />
			<div style={CONTAINER_STYLE}>
				<div className="dashboard-text">Super Admin Dashboard</div>
				<div id="admin">
					<div>
						<div className="row format">
							<Sidenavbar />
							<div className="col-8">
								{loading ? (
									<div className="text-center p-4">
										Loading course statistics...
									</div>
								) : error ? (
									<div className="text-center p-4 text-danger">{error}</div>
								) : (
									<>
										<div className="row format" style={DASHBOARD_ROW_STYLE}>
											{dashboardCards}
										</div>
										<div className="row mt-4" style={TABLE_CONTAINER_STYLE}>
											<div className="col">
												<h4 className="feedbacklist-text">Feedbacks List</h4>
												<Table>
													<thead id="pl">
														<tr>
															<th>S.No</th>
															<th>Course Name</th>
															{/* <th>Category Name</th>
												<th>Sub Category Name</th> */}
															<th>User Name</th>
															<th>Email Address</th>
															<th>Phone No</th>
															<th>Feedback</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>{feedbackRows}</tbody>
												</Table>
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Coursemanagement;
